export default "__VITE_ASSET__D0stj5UK__"